import React, {memo} from 'react';
import Breadcrumbs from "@/app/components/breadcrumbs";
import styles from "./styles.module.scss";
import userCreateAMatch from "@/app/features/create_a_match/slice";
import BottomSheet from "@/app/components/bottom_sheet/widget";
import PeopleNearYou from "@/app/features/find_players/components/people_near_you/widget";
import UsersAndLocation from "@/app/components/users_and_location";
import Button from "@/app/components/button";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import {useMediaQuery} from "@/app/utils/custom_function";
import {TextBold20, TextMedium16, ThirtyText} from "@/app/components/texts";
import TimeRangeWidget from "@/app/components/time_range_widget/widget";
import SkillLevelWidget from "@/app/components/skill_level_widget/widget";
import SelectDayAndMonth from "@/app/components/select_day_and_month/widget";
import UserRowWidget from "@/app/components/user_row_widget";
import CourtInfoWidget from "@/app/components/court_info_widget/widget";
import LazyAssets from "@/app/utils/assets_widget";
import TextButton from "@/app/components/text_button/widget";
import IconButton from "@/app/components/icon_button";
import Input from "@/app/components/input";

const CreateAMatchPage = () => {
  const isDesktop = useMediaQuery('(min-width:1024px)');
  const {
    state,
    toggleSelectUser,
    selectUser,
    goToSelectMap,
    createMatch,
    onSelectTimeRange,
    onSelectSkillLevel,
    onSelectEventDate,
    onCommentMessageChange,
    disabledCreateMatch,
    isCreatingMatch
  } = userCreateAMatch();

  return (
    <div className={styles.createAMatch}>
      <Breadcrumbs items={state.items}/>

      {isDesktop ? (
        <div className={styles.desktopLayout}>
          {/* First Column - All Information */}
          <div className={styles.column}>
            <TimeRangeWidget onSelect={onSelectTimeRange} value={state.timeRange}/>
            <SkillLevelWidget onSelect={onSelectSkillLevel} value={state.skillLevel}/>
            <SelectDayAndMonth initialDate={state.eventDate} onChange={onSelectEventDate}/>
            <div className={styles.section}>
              <div className={styles.title}>
                <ThirtyText text={t(s.matchInfo)}/>
              </div>
              <Input 
                onChange={onCommentMessageChange} 
                hint={t(s.text)}
                className={styles.inputAboutMe}
                value={state.commentMessage}
                limit={200} 
                isTextArea
              />
            </div>
            <div className={styles.section}>
              <div className={styles.title} onClick={toggleSelectUser}>
                <ThirtyText text={t(s.youPlayWith)}/>
                <LazyAssets.Add className={styles.add}/>
              </div>
              <div className={styles.usersList}>
                {state.users && state.users.length > 0 ? (
                  state.users.map(user => (
                    <UserRowWidget
                      key={user.id}
                      user={user}
                      onClick={() => {
                      }}
                      isDesktop={isDesktop}
                    />
                  ))
                ) : (
                  <div className={styles.notSelected}>
                    <ThirtyText text={t(s.noOtherPlayers)}/>
                    <Button text={t(s.selectUsers)} isViolet onClick={toggleSelectUser}/>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Second Column - Location */}
          <div className={styles.column}>
            <div className={styles.section}>
              <div className={styles.title}>
                <ThirtyText text={t(s.location)}/>
                <TextButton text={t(s.change)} onClick={goToSelectMap} isMedium withUnderLine/>
              </div>
              <div className={styles.location}>
                {!state.location ? (
                  <div className={styles.notSelected}>
                    <TextMedium16 text={t(s.courtNotSelected)}/>
                    <Button text={t(s.selectACourt)} isViolet onClick={goToSelectMap}/>
                  </div>
                ) : (
                  <CourtInfoWidget
                    data={state.location}
                    reviews={state.reviews}
                    goToCreateMatch={goToSelectMap}
                    courtOnMatch
                  />
                )}
              </div>
            </div>
          </div>

          {/* Third Column - Button */}
          <div className={styles.column}>
            <div className={styles.columnContent}>
              <ThirtyText text={t(s.createAMatch)}/>
              <TextBold20 text={t(s.afterOpponentsConfirm)}/>
            </div>
            <div className={styles.buttons}>
              <Button
                text={t(s.createAMatch)}
                onClick={createMatch}
                isDisabled={disabledCreateMatch()}
                isLoading={isCreatingMatch}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* Mobile Layout */}
          <TimeRangeWidget onSelect={onSelectTimeRange} value={state.timeRange}/>
          <SkillLevelWidget onSelect={onSelectSkillLevel} value={state.skillLevel}/>
          <SelectDayAndMonth initialDate={state.eventDate} onChange={onSelectEventDate}/>
          <div className={styles.section}>
            <div className={styles.title}>
              <TextBold20 text={t(s.matchInfo)}/>
            </div>
            <Input 
              onChange={onCommentMessageChange} 
              label={t(s.describeYourself)}
              hint={t(s.text)}
              className={styles.inputAboutMe}
              value={state.commentMessage}
              limit={200} 
              isTextArea
            />
          </div>
          <UsersAndLocation
            users={state.users}
            location={state.location}
            toggleSelectUser={toggleSelectUser}
            goToSelectMap={goToSelectMap}
            reviews={state.reviews}
          />
          <div className={styles.buttons}>
            <Button
              text={t(s.createAMatch)}
              onClick={createMatch}
              isDisabled={disabledCreateMatch()}
              isLoading={isCreatingMatch}
            />
          </div>
        </>
      )}

      <BottomSheet open={state.showSelectUser} onClose={toggleSelectUser} withPadding>
        <IconButton className={styles.close} icon={<LazyAssets.Close/>} onClick={toggleSelectUser}/>
        <PeopleNearYou inChat={true} onClick={selectUser} withoutButtons/>
      </BottomSheet>
    </div>
  );
};

export default memo(CreateAMatchPage);
